export default "<button class=\"transparent-button\"><fa-icon [icon]=\"faArrowCircleRight\"></fa-icon><ng-content></ng-content></button>\n"